module.exports = __webpack_public_path__ + "static/media/STAX-CAKE.33296199.svg";